<script lang="ts">
  import NextButton from './NextButton.svelte';
  import TitleBar from './TitleBar.svelte';
  import Logo from './Logo.svelte';
  import { currentDate, currentMonth, month, year } from '../stores/appData';
  import { setNewDate, toggleOpen } from '../util';

  let { getOffSet, reset = () => null } = $props();

  let nextMonth = $derived($currentMonth + 1);
  let previousMonth = $derived($currentMonth - 1);

  let monthAndYear = $derived(`${$month} ${$year}`);
</script>

<div class="logo">
  <Logo colored on:click={() => currentDate.set(new Date())} />
</div>
<div class="current-month">
  <NextButton
    aria-label="Go to previous month"
    direction="previous"
    on:click={() => {
      reset();
      setNewDate($year, previousMonth);
      setTimeout(getOffSet, 1);
    }}
  />
  <TitleBar year={$year} month={$month} {monthAndYear} />
  <NextButton
    aria-label="Go to next month"
    on:click={() => {
      reset();
      setNewDate($year, nextMonth);
      setTimeout(getOffSet, 1);
    }}
  />
</div>
<div
  class="mobileMenu"
  onclick={toggleOpen}
  onkeydown={e => e.key === 'Enter' && toggleOpen()}
  role="button"
  tabindex="0"
  aria-label="Toggle mobile menu"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
    ><path d="M0 0h24v24H0V0z" fill="none" /><path
      d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    /></svg
  >
</div>

<style>
  .current-month {
    grid-column: 1 / -1;
    font-size: 2rem;
    text-align: center;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
  }

  @media screen and (max-width: 768px) {
    .current-month {
      font-size: 1rem;
      grid-column: 2 / -2;
    }
  }

  @media screen and (max-height: 1000px) and (min-width: 769px) {
    .current-month {
      font-size: 1rem;
      grid-column: 2 / -2;
    }
  }

  @media print {
    .current-month {
      grid-template-columns: 1fr;
    }
  }

  .logo,
  .mobileMenu {
    display: none;
  }

  @media screen and (max-width: 768px) {
    .logo,
    .mobileMenu {
      display: block;
      align-self: center;
      justify-self: center;
    }
  }

  @media screen and (max-height: 1000px) and (min-width: 769px) {
    .logo,
    .mobileMenu {
      display: block;
      align-self: center;
      justify-self: center;
    }
  }

  @media screen and (max-height: 1000px) and (min-width: 769px) {
    .mobileMenu svg {
      fill: var(--primaryText);
    }
  }

  @media screen and (max-width: 768px) {
    .mobileMenu svg {
      fill: var(--primaryText);
    }
  }
</style>
